import { Badge, BadgeSize, BadgeVariant } from "shared/components";
import { Card } from "shared/components/Card";
import { MetaAdsPage } from "types/landlord/meta-ads";

const formatRelative = (iso: string | null): string => {
  if (!iso) return "never";

  const then = new Date(iso).getTime();
  const diffMs = Date.now() - then;
  if (diffMs < 0) return "in the future";

  const minutes = Math.floor(diffMs / 60_000);
  if (minutes < 1) return "just now";
  if (minutes < 60) return `${minutes} min ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;

  const days = Math.floor(hours / 24);
  return `${days}d ago`;
};

interface ConnectedPagesListProps {
  pages: MetaAdsPage[];
}

export const ConnectedPagesList = ({ pages }: ConnectedPagesListProps) => {
  if (pages.length === 0)
    return (
      <Card className="p-6">
        <p className="text-sm text-content-400">
          No Facebook Pages are connected yet. Reconnect to grant access to your
          Pages.
        </p>
      </Card>
    );

  return (
    <div className="flex flex-col gap-3">
      {pages.map((page) => (
        <Card className="p-6" key={page.id}>
          <div className="flex items-center justify-between">
            <div className="flex flex-col gap-1">
              <p className="text-base font-bold text-content-1000">
                {page.page_name}
              </p>
              <p className="text-xs text-content-400">
                Last webhook: {formatRelative(page.last_webhook_at)}
              </p>
            </div>
            {page.leadgen_subscribed_at ? (
              <Badge variant={BadgeVariant.SUCCESS} size={BadgeSize.SM}>
                Subscribed
              </Badge>
            ) : (
              <Badge variant={BadgeVariant.WARNING} size={BadgeSize.SM}>
                Not subscribed
              </Badge>
            )}
          </div>
          <div className="mt-3 pt-3 border-t border-alpha-40 flex gap-6">
            <div>
              <p className="text-xs text-content-400">Leads received</p>
              <p className="text-sm font-bold text-content-1000">
                {page.leads_created_count}
              </p>
            </div>
            <div>
              <p className="text-xs text-content-400">Webhooks received</p>
              <p className="text-sm font-bold text-content-1000">
                {page.webhooks_received_count}
              </p>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};
